module.exports = __webpack_public_path__ + "img/yw_ydrk.89816b58.svg";